export const pathNames = {
	home: "/",
	search: "/search",
	drivers: "/software/drivers",
	driversCategory: "/software/drivers/{category}",
	driversDetails: "/software/drivers/{category}/{partNumber}",
	solutions: "/solutions",
	solutionDetails: "/solutions/{solution}",
	events: "/events",
	eventsDetails: "/events/{event}",
	newsroom: "/newsroom",
	expandedCodeFusionArticle:"/newsroom/analog-devices-introduces-expanded-codefusion-studio",
	pressRelease:"/newsroom/analog-devices-launches-codefusion-studio-and-developer-portal",
	article1:"/newsroom/equipping-developers-for-a-multi-core-heterogeneous-future",
	article2: "/newsroom/advancing-security-at-the-intelligent-edge",
	openSource: "/open-source",
	documentation: "/documentation",
	pages: "/pages",
	pagesDetails: "/pages/{page}",
	cms: "/cmadmin",
	cmsLogout: "/cmadmin/logout",
	cmsEvents: "/cmadmin/events",
	cmsEventsNew: "/cmadmin/events/new",
	cmsEventsEdit: "/cmadmin/events/{event}",
	cmsSolutions: "/cmadmin/solutions",
	cmsSolutionsNew: "/cmadmin/solutions/new",
	cmsSolutionsEdit: "/cmadmin/solutions/{solution}",
	cmsPages: "/cmadmin/pages",
	cmsPagesNew: "/cmadmin/pages/new",
	cmsPagesEdit: "/cmadmin/pages/{page}",
	cmsImageUpload: "/cmadmin/image-upload",
};

// List of Pages that have unique URLs (example /open-source, they will be accessible at /pages/* too)
export const customPagePaths = [
	pathNames.openSource,
	pathNames.documentation,
	pathNames.newsroom,
	pathNames.pressRelease,
].map((str: string) => str.replace(/^\//, ""));
